export default "__VITE_ASSET__Dy9ZzoWc__"